
class ModalManager {
    private static listeners: Array<(options: unknown) => void> = [];

    // Register listener to show/hide the modal
    static subscribe(listener: (options: unknown) => void) {
        this.listeners.push(listener);
    }

    // Unsubscribe when component unmounts
    static unsubscribe(listener: (options: unknown) => void) {
        this.listeners = this.listeners.filter((l) => l !== listener);
    }

    // Trigger the modal
    static show(options: { 
        size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full',
        header: string, 
        message: string, 
        messageDetails?: string | null,
        showActionButton?: boolean, 
        actionButtonText?: string, 
        showCancelButton?: boolean, 
        cancelButtonText?: string, 
        hideHeaderCloseIcon?: boolean, 
        onConfirm?: () => void, 
        onCancel?: () => void 
    }) {
        const defaultOptions = {
            size: 'xs',
            messageDetails: '',
            showActionButton: true,
            actionButtonText: 'Confirm',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            hideHeaderCloseIcon: false,
            onConfirm: () => {},
            onCancel: () => {}
        };

        const finalOptions = { ...defaultOptions, ...options, show: true };

        this.listeners.forEach((listener) => listener(finalOptions));
    }

    // Close the modal
    static close() {
        this.listeners.forEach((listener) => listener({ show: false }));
    }
}

export default ModalManager;
